import { render, staticRenderFns } from "./OnboardingVerificationRecord.vue?vue&type=template&id=c99423fc&"
import script from "./OnboardingVerificationRecord.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerificationRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports